<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>人物管理 > <b>火山音色列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
        
			<span class="search_span_width">
	         <span class="search_span_width_part1">音色：</span>
	       				 <Input v-model="search.model_id" style="width: 130px" clearable/>
	       	</span>
			   <span class="search_span_width">
	         <span class="search_span_width_part1">音色名称：</span>
	       				 <Input v-model="search.voice_name" style="width: 130px" clearable/>
	       	</span>
        <span class="search_span_width">
				<span class="search_span_width_part1">客户：</span>
				<Select style="width:200px"
                clearable
                v-model="search.user_id"
                filterable
                :remote-method="userlist"
                :loading="loading2">
					 <Option v-for="(option, index) in user_list" :value="option.id" :key="index">{{option.mobile}}</Option>
				</Select>
			</span>
        <span class="search_span_width">
	             <span class="search_span_width_part1">是否启用：</span>
					<Select v-model="search.is_open" clearable  style="width:130px">
						   <Option :value='0'>未启用</Option>
						   <Option :value='1'>已启用</Option>
					</Select>
	      </span>
        <span class="search_span_width">
	             <span class="search_span_width_part1">是否分配：</span>
					<Select v-model="search.is_allot" clearable  style="width:130px">
						   <Option :value='0'>未分配</Option>
						   <Option :value='1'>已分配</Option>
					</Select>
	      </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getVoiceSpeakerList()">搜索</Button>
      </Card>
      <Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="voice_speaker_list"></Table>
		  <Page :total="recordTotal" :current="page" :page-size="20" :show-elevator="true" @on-change="getVoiceSpeakerList"/>
        </Card>
      </Card>
    </Content>
    <Modal v-model="showinfomodal" :footer-hide=true title="编辑">
      <Form ref="voice_train" :model="voice_train_speaker" :label-width="80" >
        <FormItem label="ID" prop="id">
          <Input v-model="voice_train_speaker.id"  disabled/>
        </FormItem>
<!--
        <FormItem label="绑定用户" prop="voice_name">
          <Select style="width:200px"
                  clearable
                  v-model="voice_train_speaker.user_id"
                  default-label="voice_train_speaker.nickname"
                  filterable
                  :remote-method="userlist"
                  :loading="loading2">
            <Option v-for="(option, index) in user_list" :value="option.id" :key="index">{{option.nickname}}</Option>
          </Select>
        </FormItem>-->
        <FormItem label="绑定用户ID" prop="user_id">
          <Input v-model="voice_train_speaker.user_id"  />
        </FormItem>
        <FormItem label="名称" prop="voice_name">
          <Input v-model="voice_train_speaker.voice_name"  />
        </FormItem>
        <FormItem label="音色" prop="model_id">
          <Input v-model="voice_train_speaker.model_id"disabled />
        </FormItem>
        <FormItem label="音色状态" prop="is_allot" >
          <RadioGroup v-model="voice_train_speaker.is_allot">
            <Radio label='0' >未分配</Radio>
            <Radio label='1' >已分配</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="是否启用" prop="is_open">
          <RadioGroup v-model="voice_train_speaker.is_open">
            <Radio label="0">未启用</Radio>
            <Radio label="1">已启用</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="updateVoiceTrainSpeaker()">提交</Button>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="showRecharge" :footer-hide=true title="音色续费" >
      <Form  :model="rechargeForm" :label-width="80" >
        <FormItem label="音色ID">
          <Input v-model="rechargeForm.voice_id"  :disabled=true />
        </FormItem>
        <FormItem label="充值时长">
          <InputNumber  :precision="0" min=0 :max="12" v-model="rechargeForm.recharge_month" />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="rechargeVoice()">提交</Button>
        </FormItem>
      </Form>
    </Modal>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
		search : {
      model_id:'',
      voice_name:'',
      user_id:"",
      is_allot:'',
      is_open:''
		},
		page: 1,
		loading2: false,
    showinfomodal:false,
    showRecharge: false,
		recordTotal:0,
		voice_speaker_list:[],
    user_list:[],
    rechargeForm:{
      recharge_month:0,
      voice_id:""
    },
    user_list_all:[],
    voice_train_speaker:{
      id:0,
      user_id:'',
      voice_source:"",
      voice_name:'',
      nickname:'',
      model_id:'',
      is_open:'0',
      is_allot:"0"
    },
		tableColumns:[
      { title: '音色编号', key: 'model_id', align: 'center' },
      { title: '音色实例ID', key: 'InstanceNO', align: 'center' },
		  { title: '音色名称', key: 'voice_name', align: 'center' },
      { title: '分绑定用户', key: 'nickname', align: 'center' },
      { title: '音色复刻次数', key: 'clone_num', align: 'center' },
      { title: '是否分配', key: 'is_allot', align: 'center',
        render: (h, params) => {
          var txt = '';
          if (params.row.is_allot =='1') {
            txt = '已分配';
          } else {
            txt = '未分配';
          }

          return h("div",{},txt);
        }
      },
      { title: '是否启用', key: 'is_open', align: 'center',
        render: (h, params) => {
          var txt = '';
          if (params.row.is_open =='1') {
            txt = '已启用';
          }else{
            txt = '未启用';
          }
          return h("div",{},txt);
        }
      },
      { title: '启用时间', key: 'start_time', align: 'center',
        render: (h, params) => {
          var txt = '';
          if (params.row.start_time =="0") {
            txt = '-';
          }else{
            txt = params.row.start_time;
          }
          return h("div",{},txt);
        }
      },
      { title: '到期时间', key: 'expire_time', align: 'center' },
		  { title: '创建时间', key: 'created_at', align: 'center' },
      { title: '操作', key: 'action', align: 'center',width: 300,
        render: (h, params) => {
          let btns=[]
          btns.push(
              h('Button', {
                props: { type: 'success', size: 'small' },
                style: { marginRight: '5px', marginBottom: '5px'},
                on: {
                  click: () => {
                    this.rechargeForm.voice_id = params.row.model_id
                    this.showRecharge = true;
                  }
                }
              }, '续费')
          );
          btns.push(
              h('Button', {
                props: { type: 'warning', size: 'small' },
                style: { marginRight: '5px', marginBottom: '5px'},
                on: {
                  click: () => {
                    this.voice_train_speaker.id = params.row.id;
                    this.voice_train_speaker.user_id = params.row.user_id;
                    this.voice_train_speaker.voice_source = params.row.voice_source;
                    this.voice_train_speaker.voice_name = params.row.voice_name;
                    this.voice_train_speaker.nickname = params.row.nickname;
                    this.voice_train_speaker.model_id =params.row.model_id;
                    this.voice_train_speaker.is_allot =params.row.is_allot.toString();
                    this.voice_train_speaker.is_open =params.row.is_open.toString();
                    this.showinfomodal = true;
                  }
                }
              }, '编辑')
          );
          if (params.row.is_open == '0') {
            var txt = '重置音色';
            btns.push(
                h('Button', {
                  props: { type: 'error', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px'},
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        content: '<p>确定'+txt+'吗？</p>',
                        onOk: () => {
                          this.resetVoiceTrainSpeaker(params.row.id);
                        }
                      });
                    }
                  }
                }, txt),
            );
          }
          return h("div",btns);
        }
      }
		]
	}
  },
  mounted:function(){
    this.getVoiceSpeakerList();
  },
  computed:{

  },
  methods:{
    getVoiceSpeakerList(page=this.page) {
		this.page = page;
		let p = {'page' : page}
		let params = Object.assign(this.search, p);
		this.http1.get('/voice/voiceTrainSpeakerlist',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.voice_speaker_list = data.res.list;
			this.recordTotal = data.res.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
    userlist(query){
      if (query !== '' && query.length==11) {
        this.loading2 = true;
        setTimeout(() => {
          this.loading2 = false;

          this.http.get('/admin/user/userList',{params:{mobile:query}}).then(response=>{
            let data=response.data;
            if(data.code!==0)
            {
              alert(data.message);
            } else{
              this.user_list = data.data.list;
            }
          }).catch(()=>{
            this.$Message.error('网络错误');
          });

        }, 200);
      }
    },
    resetVoiceTrainSpeaker(speaker_id){
      this.http1.post('/voice/resetVoiceTrainSpeaker',{speaker_id:speaker_id}).then(response=>{
        let data=response.data;
        if(data.code!==0) {
          this.$Message.error(data.message);
          return false;
        } else{
          this.$Message.info(data.message);
          this.getVoiceSpeakerList(this.page);
          return true;
        }
      });
    },
    updateVoiceTrainSpeaker(){
      this.$Modal.confirm({
        content: '<p>确定提交？</p>',
        onOk: () => {
          this.http1.post('/voice/updateVoiceTrainSpeaker',this.voice_train_speaker
          ).then(response=>{
            let data=response.data;
            if(data.code!==0) {
              this.$Message.error(data.message);
              return false;
            }else{
              this.$Message.info(data.message);
              this.showinfomodal =false;
              this.getVoiceSpeakerList(this.page);
              return true;
            }
          });
        }
      });

    },
    rechargeVoice(){
      if(!this.rechargeForm.recharge_month){
        this.$Message.warning('充值时长不能为空');
        return false;
      }
      this.http.post('/admin/figure/rechargeVoice',this.rechargeForm).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.showRecharge = false;
          this.search={}
          this.$Message.success('充值成功');
          this.getVoiceSpeakerList();
        }
      }).catch(e=>{
        console.log(e)
        this.$Message.error('网络错误');
      });
    },
  }

}
</script>
